import { LATEST_SCHEMA_VERSION as i } from "../types/index.js";
import { TableColumnFormatType as r } from "@decentriq/graphql/dist/enums";
const a = (t) => {
  const e = ["byte", "kilobyte", "megabyte", "gigabyte", "terabyte", "petabyte"], n = Math.floor(Math.log(t) / Math.log(1024));
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 1,
    style: "unit",
    unit: e[n],
    unitDisplay: "narrow"
  }).format(t / 1024 ** n);
}, f = (t) => {
  if (t === "" || t === null || t === void 0)
    return r.String;
  if (typeof t == "string") {
    if (t.match(/^\d+$/))
      return r.Integer;
    if (t.match(/^\d+\.\d+$/))
      return r.Float;
    if (t.match(/^\d{4}-\d{2}-\d{2}$/))
      return r.DateIso8601;
    if (t.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/))
      return r.Email;
    if (t.match(/^\+[0-9]{1,15}$/))
      return r.PhoneNumberE164;
  }
  return typeof t == "number" ? Number.isInteger(t) ? r.Integer : r.Float : r.String;
}, u = (t) => t && {
  ...t,
  version: i
};
export {
  a as formatSize,
  u as getLatestVersionedSchema,
  f as guessFormatType
};
//# sourceMappingURL=index.js.map
